<template lang="html">
  <div v-if="publication !== undefined">
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
              >
                <v-list-item
                  :to="'/publications/' + publication.id + form.path"
                  class="text-left"
                >
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-card class="mt-4 pa-6">
      <div class="text-left mb-4">
        {{ $t("personal.data.info") }}
      </div>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="publication.title"
            :label="$t('form.title')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="publication.abstract"
            :label="$t('form.abstract')"
            required
            readonly
            filled
            outlined
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="publication.keywords"
            :label="$t('form.keywords')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="authors"
            :label="$t('form.authors')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="publication.authors_text"
            :label="$t('form.authors_text')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="5">
          <v-text-field
            v-model="publication.doi"
            :label="$t('form.doi')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="publication.isbn"
            :label="$t('form.isbn')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="publication.num_authors"
            :label="$t('form.num_authors')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :value="
              publication.research_areas.map(function(item) {
                return item.name[$i18n.locale];
              })
            "
            :label="$t('form.publication.research_areas')"
            required
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <DetailArticle
        v-if="publication.article !== null"
        :article="publication.article"
      />
      <DetailBookChapter
        v-if="publication.bookandchapter !== null"
        :book-chapter="publication.bookandchapter"
      />
      <DetailThesis
        v-if="publication.thesis !== null"
        :thesis="publication.thesis"
      />
      <DetailCommunication
        v-if="publication.communication !== null"
        :communication="publication.communication"
      />

      <v-row>
        <v-col class="text-center">
          <v-btn
            text
            type="submit"
            class="btn-large-space btn-danger"
            v-on:click="$router.go(-1)"
            >{{ $t("button.back") }}</v-btn
          >
          <DeleteReasonBtn
            url-objects="publication"
            object_type="publication"
            :headers="headers"
            :item="publication"
          />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script type="text/javascript">
import axios from "axios";
import DeleteReasonBtn from "../delete_object/DeleteObjectForm";
import DetailArticle from "./DetailArticle";
import DetailBookChapter from "./DetailBookChapter";
import DetailThesis from "./DetailThesis";
import DetailCommunication from "./DetailCommunication";
export default {
  components: {
    DetailCommunication,
    DetailThesis,
    DetailArticle,
    DeleteReasonBtn,
    DetailBookChapter
  },
  data() {
    return {
      authors: "",
      tab: null,
      publication: undefined,
      forms: [
        {
          title: "publication.forms.modifyBasicData",
          path: "/forms/modifyBasicDataForm",
          icon: "mdi-pencil"
        }
      ]
    };
  },

  computed: {
    headers() {
      return [{ text: this.$t("title.title"), value: "title", width: "15%" }];
    }
  },

  methods: {
    getPublication() {
      const path =
        this.$store.state.endpoint +
        "/user/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.publication = response.data;
        })
        .finally(() => {
          this.getNameAuthors();
          this.setBreadcrumb();
        })
        .catch(error => {
          console.log(error);
          this.$router.push("/publications");
        });
    },
    getNameAuthors() {
      this.publication.authorsrel.forEach(author => {
        this.authors === ""
          ? (this.authors =
              author.position +
              "- " +
              author.person.preferred_name.given_name +
              " " +
              author.person.preferred_name.family_name)
          : (this.authors +=
              ", " +
              author.position +
              "- " +
              author.person.preferred_name.given_name +
              " " +
              author.person.preferred_name.family_name);
      });
    },

    setBreadcrumb() {
      let item = {
        text: this.publication.title,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        this.$route.meta.breadCrumb.push(item);
      } else {
        this.$route.meta.breadCrumb.pop();
        this.$route.meta.breadCrumb.push(item);
      }
      this.$store.state.sectionTitle = this.publication.title;
    }
  },

  created() {
    this.getPublication();
  }
};
</script>
